import { api, transformResponse } from './axios'

export const fetchGetTelegramChatList = (token: string) =>
  transformResponse(
    api.get(`/telegram-chats`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    }),
  )
